import { Injectable, inject } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from '../user/user.service';
import { UserBonusesService } from "../user/user-bonuses.service";

@Injectable({
  providedIn: 'root'
})
export class FreespinsGamesService {
  private _user = inject(UserService);
  private _bonus = inject(UserBonusesService);


  /**
   * Emit providers list for favorite games
   */
  public freespinsProviders$: ReplaySubject<number[]> = new ReplaySubject<number[]>(1);

  /**
   * Returns ready to use favorite games list
   */
  public getMappedGameList(): Observable<any> {
    if (this._user.auth) {
      return this._bonus.freeSpinsActivatedGameList().pipe(
        tap(list => this.freespinsProviders$.next(list && list.gameList && list.gameList.map(game => game.providerId))),
      );
    } else {
      this.freespinsProviders$.next([]);
      return of([]);
    }
  }
}
